import { render, staticRenderFns } from "./CustomCalendar.vue?vue&type=template&id=31ccefde&scoped=true"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"
import style0 from "./CustomCalendar.vue?vue&type=style&index=0&id=31ccefde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccefde",
  null
  
)

export default component.exports